// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"1b6b2aa2ebfa720b5b05","691":"2fe5fd567da08c36480c","731":"5281f159936558d7ea0c","843":"c51a783d86c3c3b67fb4"}[chunkId] + ".js";
};